import { Box, Flex, Image, Text, UnorderedList, ListItem, Highlight } from '@chakra-ui/react';
import React from 'react';

const PrepleafElite = ({ data }: any) => {
	return (
		<Flex p={['43px 16px 50px 16px', '29px 80px 0px 80px']} justifyContent="center" alignItems="center">
			<Flex
				borderRadius="24px"
				border="1px solid #FFE180"
				w={{ base: '342px', md: '1280px' }}
				h={{ base: '330px', lg: '238px' }}
				bg="#FFF9E5"
				position="relative"
				overflow="hidden"
				flexDirection={['column', 'column', 'column', 'column', 'column', 'row']}
			>
				<Box
					w={{ base: '152px', lg: '249px' }}
					h={{ base: '152px', lg: '249px' }}
					borderRadius="249px"
					bg="#FFF3CC"
					position="absolute"
					top="-75px"
					left={{ base: '0px', lg: '70px' }}
					right={{ base: '0px', lg: '1000px' }}
					mx={'auto'}
				></Box>
				<Image
					w={{ base: '78px', lg: '151px' }}
					h={{ base: '78px', lg: '151px' }}
					position="absolute"
					top="-10px"
					left={{ base: '0px', lg: '120px' }}
					right={{ base: '0px', lg: '1000px' }}
					mx={'auto'}
					src={'https://masai-website-images.s3.ap-south-1.amazonaws.com/medal_c7935ac76e.svg'}
					zIndex="1"
				/>
				<Flex
					flexDirection="column"
					alignItems={{ base: 'center', lg: 'flex-start' }}
					justifyContent="center"
					gap="16px"
					position="absolute"
					top={{ base: '100px', lg: '20px' }}
					left={{ base: '10px', lg: '400px' }}
				>
					<Flex flexDirection="column" gap="6px">
						<Text textStyle={{ base: 'h6', lg: 'h3' }}>{data?.heading || 'We have something more for you!'}</Text>
						<Text textStyle={{ base: 'h3', lg: 'h2' }} color="#CC926E">
							{data?.title || 'Prepleaf Elite Program'}
						</Text>
					</Flex>
					<Flex flexDirection={'column'} gap={'12px'}>
						<UnorderedList>
							{data && data?.points?.length ? (
								data?.points?.map((point: { text: string; highlight: string }, index: number) => (
									<ListItem key={index} textStyle="body-1">
										<Highlight query={point?.highlight} styles={{ color: '#4358F6', fontWeight: '600' }}>
											{point?.text}
										</Highlight>
									</ListItem>
								))
							) : (
								<></>
							)}
						</UnorderedList>
					</Flex>
				</Flex>
			</Flex>
		</Flex>
	);
};

export default PrepleafElite;
